import { IntercomPlugin } from '../../api/intercom/get/loadIntercomPlugins';
import { Thread } from '../../types/thread';
import { RootState } from '../rootReducer';
import { Intercom } from './actions';

export const getIntercomState = (state: RootState): Intercom => state.intercom;
export const getIntercomThreadByIdState = (state: RootState, id: string) : Thread => state.intercom?.threads?.find((thread) => thread.id === id);
export const getIntercomPluginsState = (state: RootState): Array<IntercomPlugin> => state.intercom.plugins;
